export default __webpack_public_path__ + "static/media/ribbon1.d398c6a4.svg";